// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"f2f4d24d","71":"5a145105","313":"3a7bd19e","512":"e6762d97","681":"0ceda397","801":"2c670c1e","805":"d385b285","902":"bb75035d"}[chunkId] + ".chunk.js";
};